import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_API_URL } from '../../../../utils/constants';
import { myFirebaseAuth } from '../../../../firebase/config';
import { CollectionSequenceBuyerProgress } from '@dill/dill-shared';

// A single fetch-the-whole-map hook mirroring useCollectionBuyerEngagements, for views that need
// every buyer's current sequence step at once (e.g. AR Aging) rather than one buyer at a time
// (see BuyerCollectionSequenceEnrollments.tsx for the per-buyer equivalent).
export const useCollectionSequenceBuyerProgress = (supplierId: string) => {
  const [progressByBuyerId, setProgressByBuyerId] = useState<
    Record<string, CollectionSequenceBuyerProgress>
  >({});
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!supplierId) return;
    setIsLoading(true);
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) return;
      const response = await axios.get(
        `${BASE_API_URL}/suppliers/${supplierId}/collectionSequences/getSupplierCollectionSequenceBuyerProgress`,
        { headers: { Authorization: 'Bearer ' + token } }
      );
      const data: Record<string, CollectionSequenceBuyerProgress> = response.data?.success
        ? response.data.data ?? {}
        : {};
      setProgressByBuyerId(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [supplierId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { progressByBuyerId, isLoading, refresh };
};

export default useCollectionSequenceBuyerProgress;
